export const subscribeTranslations = {
  fr: {
    error: "Erreur",
    sessionInvalid: "Session non valide",
    checkoutError: "Erreur lors de la création du checkout",
    checkoutUrlMissing: "URL de checkout non reçue",
    genericError: "Une erreur est survenue",
    backToPricing: "Retour à la page tarifs",
    redirecting: "Redirection vers le paiement...",
    plan: "Plan {{plan}}",
    promoApplied: "(Code {{code}} appliqué)",
    premiumRequired: "Cette fonctionnalité nécessite un abonnement Premium.",
    viewOffers: "Voir les offres",
  },
  en: {
    error: "Error",
    sessionInvalid: "Invalid session",
    checkoutError: "Error creating checkout",
    checkoutUrlMissing: "Checkout URL not received",
    genericError: "An error occurred",
    backToPricing: "Back to pricing page",
    redirecting: "Redirecting to payment...",
    plan: "Plan {{plan}}",
    promoApplied: "(Code {{code}} applied)",
    premiumRequired: "This feature requires a Premium subscription.",
    viewOffers: "View offers",
  },
  es: {
    error: "Error",
    sessionInvalid: "Sesión no válida",
    checkoutError: "Error al crear el checkout",
    checkoutUrlMissing: "URL de checkout no recibida",
    genericError: "Se produjo un error",
    backToPricing: "Volver a la página de precios",
    redirecting: "Redirigiendo al pago...",
    plan: "Plan {{plan}}",
    promoApplied: "(Código {{code}} aplicado)",
    premiumRequired: "Esta función requiere una suscripción Premium.",
    viewOffers: "Ver ofertas",
  },
};
